import React from "react";
import DeepSeekStatCards from "./DeepSeekStatCards";
import DeepSeekUserSchoolBreakdown from "./DeepSeekUserSchoolBreakdown";
import DeepSeekTopicStats from "./DeepSeekTopicStats";
import DeepSeekUsageCharts from "./DeepSeekUsageCharts";

const DeepSeekStats = ({ stats, loading, onSelectUser, t }) => {
    if (loading) {
        return (
            <div className="text-center py-5 my-5 w-100">
                <i className="fal fa-spinner fa-spin fa-3x text-primary mb-3"></i>
                <p className="text-muted small">{t('Processing') || "جاري تحميل البيانات..."}</p>
            </div>
        );
    }

    return (
        <div className="deepseek-welcome-screen">
            {/* Main Stats Cards Grid */}
            <DeepSeekStatCards stats={stats} t={t} />

            {/* User and School breakdown */}
            <DeepSeekUserSchoolBreakdown stats={stats} t={t} />

            {/* Top Topics, Top Categories, Pure AI, Costly Chats */}
            <DeepSeekTopicStats stats={stats} onSelectUser={onSelectUser} t={t} />

            {/* Daily Usage Charts */}
            <DeepSeekUsageCharts stats={stats} t={t} />
        </div>
    );
};

export default DeepSeekStats;
